export function mkE( par ) {
	let el = document.createElement(par.tag);
	for( let i in par ) {
		if( par.hasOwnProperty(i) && el.hasOwnProperty(i) ) {
			el[i] = par[i];
		} else if (typeof el[i] !== 'undefined') {
			el[i] = par[i];
		}
	}
	if( par.className ) {
		el.className = par.className;
	}
	if( par.text ) {
		el.textContent = par.text;
	}
	if( par.els ) {
		for( let i = 0; i < par.els.length; i++ ) {
			const child = par.els[i];
			if( child instanceof Object && child.tag ) {
				el.append(mkE(child));
			} else {
				el.append(child);
			}
		}
	}
	return el;
}
